import { Link, useLocation } from 'react-router-dom';
import { Instagram, Facebook, Youtube } from 'lucide-react';
import { useState } from 'react';
import api from '../api';
import { useToast } from '../hooks/use-toast';

export default function Footer() {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  if (location.pathname.startsWith('/admin') || location.pathname === '/auth-callback') return null;

  const submitNewsletter = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post('/newsletter', { email });
      toast({ title: 'Subscribed', description: 'Thank you for joining our quiet newsletter.' });
      setEmail('');
    } catch { toast({ title: 'Could not subscribe' }); }
  };
  return (
    <footer className="bg-[#1a1a1a] text-[#E8DFD1] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-20 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="font-serif-display text-3xl mb-4">barebasics<span className="text-[#C6410E]">.</span></div>
          <p className="text-sm text-[#E8DFD1]/70 leading-relaxed max-w-xs">
            Everyday leather objects, made by hand in small workshops. Made to be used, and made to last.
          </p>
        </div>

        <div>
          <h4 className="text-[11px] tracking-widest-plus uppercase mb-4 text-[#E8DFD1]/60">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/bags" className="link-underline">Bags</Link></li>
            <li><Link to="/shop/desk" className="link-underline">The Desk</Link></li>
            <li><Link to="/shop/small-leather" className="link-underline">Small Leather Goods</Link></li>
            <li><Link to="/shop/gifting" className="link-underline">Gifting</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] tracking-widest-plus uppercase mb-4 text-[#E8DFD1]/60">The House</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/our-story" className="link-underline">Our Story</Link></li>
            <li><Link to="/our-story" className="link-underline">Craftsmanship</Link></li>
            <li><Link to="/contact" className="link-underline">Contact</Link></li>
            <li><Link to="/track" data-testid="footer-track-link" className="link-underline">Track your order</Link></li>
            <li><Link to="/contact" className="link-underline">Care Guide</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[11px] tracking-widest-plus uppercase mb-4 text-[#E8DFD1]/60">Stay in touch</h4>
          <p className="text-sm text-[#E8DFD1]/70 mb-4">A quiet newsletter, four times a year.</p>
          <form onSubmit={submitNewsletter} className="flex border-b border-[#E8DFD1]/40 pb-2">
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)} placeholder="Your email" className="bg-transparent flex-1 outline-none text-sm placeholder:text-[#E8DFD1]/40" />
            <button type="submit" className="text-[11px] tracking-widest-plus uppercase">Subscribe</button>
          </form>
          <div className="flex gap-4 mt-6">
            <a href="#" aria-label="Instagram"><Instagram className="w-4 h-4" /></a>
            <a href="#" aria-label="Facebook"><Facebook className="w-4 h-4" /></a>
            <a href="#" aria-label="Youtube"><Youtube className="w-4 h-4" /></a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#E8DFD1]/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row justify-between items-center gap-2 text-[11px] tracking-widest-plus uppercase text-[#E8DFD1]/50">
          <span>&copy; {new Date().getFullYear()} barebasics. All rights reserved.</span>
          <div className="flex gap-6">
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <a href="#">Shipping &amp; Returns</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
